import { buildTaskUpdatesWithLinks, TaskLinkUpdate } from '@griply/services';
import { useCallback } from 'react';
import { useUpdateGoalTaskCountMutation } from 'shared/hooks/queries/use-update-goal-task-count-mutation';
import { useUpdateTasksMutation } from 'shared/hooks/queries/use-update-tasks-mutation';
import { useUpdateRelationshipsReferences } from 'shared/hooks/use-update-relationships-references';

export type { TaskLinkUpdate } from '@griply/services';

// Merges the link fields into the caller's own update — the rules reject a 2nd write to a document within 100ms.
export const useUpdateTaskLinks = () => {
  const { mutate: updateTasks } = useUpdateTasksMutation();
  const { mutate: updateGoalTaskCount } = useUpdateGoalTaskCountMutation();
  const updateRelationships = useUpdateRelationshipsReferences();

  return useCallback(
    (updates: TaskLinkUpdate[]) => {
      const { taskUpdates, relationshipUpdates, goalCountDeltas } =
        buildTaskUpdatesWithLinks(updates);

      taskUpdates.length && updateTasks(taskUpdates);
      relationshipUpdates.length && updateRelationships(relationshipUpdates);
      goalCountDeltas.forEach((delta) => updateGoalTaskCount(delta));
    },
    [updateGoalTaskCount, updateRelationships, updateTasks],
  );
};
